import { useSelector } from 'react-redux';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { getSystemWebhookState } from '../selectors';
import { WEBHOOK_ERRORS } from '../constants';
import { SystemWebhookFormState } from '../types';

export const AuthenticationTokenFormField = ({
  updateWebhook,
  webhook,
}: {
  updateWebhook: (field: string, value: string) => void;
  webhook: SystemWebhookFormState;
}) => {
  const systemWebhookState = useSelector(getSystemWebhookState);
  const errors = (systemWebhookState as Record<string, any>)?.errors;
  const isMissingAuthToken = errors.includes(WEBHOOK_ERRORS.REQUIRES_TOKEN);

  return (
    <FormField
      errorText="Authentication token or API key required"
      inputId="webhookAuthTokenInput"
      labelText="Authentication Token"
      isRequired
      hasError={isMissingAuthToken}
    >
      <InputText
        id="webhookAuthTokenInput"
        hasError={isMissingAuthToken}
        onChange={(value: string) => {
          updateWebhook('authToken', value);
        }}
        data-test="webhookAuthTokenInput"
        value={webhook.authToken || ''}
      />
    </FormField>
  );
};
